(function () {
  // Global variables (scoped to this IIFE)
  let viewer = null;
  let isViewerReady = false;
  let scene = null;
  let iframe = null;
  let initializationAttempts = 0;
  const MAX_INITIALIZATION_ATTEMPTS = 10;

  // Function to initialize the viewer
  async function initializeViewer() {
    console.log("Starting initialization...");
    try {
      viewer = document.getElementById("plattar-viewer");
      if (!viewer) {
        // Not all pages include the viewer; silently skip
        return;
      }
      console.log("Found viewer element:", viewer);

      // Get the scene ID
      const sceneId = viewer.getAttribute("scene-id");
      console.log("Scene ID:", sceneId);

      // Wait for shadow DOM to be ready
      await waitForShadowRoot();

      // Add event listeners for viewer ready state
      viewer.addEventListener("ready", handleViewerReady);

      // Listen for messages from iframe
      window.addEventListener("message", handleIframeMessage);
    } catch (error) {
      console.error("Error in initialization:", error);
      retryInitialization();
    }
  }

  // Function to wait for shadow root and iframe
  function waitForShadowRoot() {
    return new Promise((resolve) => {
      const checkShadowRoot = () => {
        const shadowRoot = viewer.shadowRoot;
        if (shadowRoot) {
          console.log("Shadow root found");

          // Now wait for the iframe within the shadow root
          const waitForIframe = () => {
            iframe = shadowRoot.querySelector("iframe");
            if (iframe) {
              console.log("Iframe found in shadow root:", iframe);
              isViewerReady = true;
              setupVariationButtons();
              resolve();
            } else {
              console.log("Waiting for iframe in shadow root...");
              setTimeout(waitForIframe, 500);
            }
          };
          waitForIframe();
        } else {
          console.log("Waiting for shadow root...");
          setTimeout(checkShadowRoot, 500);
        }
      };
      checkShadowRoot();
    });
  }

  // Function to handle viewer ready event
  function handleViewerReady() {
    console.log("Viewer ready event received");
    isViewerReady = true;
    setupVariationButtons();
  }

  // Function to handle iframe messages
  function handleIframeMessage(event) {
    console.log("Received message from iframe:", event.data);

    // Handle different message types
    if (event.data) {
      switch (event.data.type) {
        case "scene.loaded":
          console.log("Scene loaded event received");
          isViewerReady = true;
          setupVariationButtons();
          break;
        case "scene.load.error":
          console.error("Scene load error:", event.data.error);
          break;
        case "scene.error":
          console.error("Scene error:", event.data.error);
          break;
        default:
          console.log("Other message received:", event.data);
      }
    }
  }

  // Function to retry initialization
  function retryInitialization() {
    initializationAttempts++;
    if (initializationAttempts < MAX_INITIALIZATION_ATTEMPTS) {
      console.log(
        `Retrying initialization (attempt ${initializationAttempts})...`
      );
      setTimeout(initializeViewer, 1000);
    } else {
      console.error("Max initialization attempts reached");
    }
  }

  // Function to fetch variation data from Plattar API
  async function fetchVariationData(variationId) {
    try {
      const response = await fetch(
        `${window.Plattar.Config.apiUrl}/v3/scene/${variationId}?include=application`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Variation data:", data);
      return data;
    } catch (error) {
      console.error("Error fetching variation data:", error);
      return null;
    }
  }

  // Function to setup variation buttons
  function setupVariationButtons() {
    console.log("Setting up variation buttons...");
    const variationControls = document.querySelector(".variation-controls");
    console.log("Variation controls element:", variationControls);

    if (!variationControls) {
      console.error("Variation controls not found");
      return;
    }

    // Get all variation buttons
    const variationButtons =
      variationControls.querySelectorAll(".variation-button");
    console.log("Found variation buttons:", variationButtons.length);

    // Set up each button's click handler
    variationButtons.forEach((button, index) => {
      const variationId = button.getAttribute("data-variation-id");
      const color = button.getAttribute("data-color");
      console.log(
        `Setting up button ${
          index + 1
        }: ${color} with variation ID: ${variationId}`
      );

      // Remove existing click listeners
      button.removeEventListener("click", handleVariationClick);

      // Add new click listener
      button.addEventListener("click", handleVariationClick);

      // Mark the first variation as active
      if (index === 0) {
        button.classList.add("active");
      }
    });
  }

  // Function to handle variation button clicks
  function handleVariationClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const variationId = button.getAttribute("data-variation-id");
    const color = button.getAttribute("data-color");
    console.log(`Variation button clicked: ${color} with ID: ${variationId}`);
    setVariation(variationId, event);
  }

  // Function to change variation
  async function setVariation(variationId, event = null) {
    console.log("Setting variation:", variationId);

    if (!isViewerReady) {
      console.warn("Viewer not ready yet, waiting...");
      await waitForViewerReady();
    }

    if (!viewer || !iframe) {
      console.error("Viewer or iframe not found");
      return;
    }

    try {
      const sceneId = viewer.getAttribute("scene-id");
      console.log("Current scene ID:", sceneId);
      console.log("Setting variation ID:", variationId);

      // Update the iframe src with both scene and variation IDs
      const newSrc = `https://app.plattar.com/renderer/viewer.html?scene_id=${sceneId}&variation_id=${variationId}`;
      console.log("Setting iframe src to:", newSrc);
      iframe.src = newSrc;

      // Update active state of buttons
      const buttons = document.querySelectorAll(".variation-button");
      buttons.forEach((button) => {
        button.classList.remove("active");
      });

      if (event && event.target) {
        event.target.classList.add("active");
      }
    } catch (error) {
      console.error("Error changing variation:", error);
    }
  }

  // Function to wait for viewer to be ready
  function waitForViewerReady() {
    return new Promise((resolve) => {
      const checkReady = () => {
        if (isViewerReady) {
          resolve();
        } else {
          setTimeout(checkReady, 500);
        }
      };
      checkReady();
    });
  }

  // Removed custom toggleARView - let Plattar handle AR/QR functionality
  // Plattar SDK provides its own QR modal when clicking View at Home

  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", initializeViewer);
})();
